import { regexOnlyNumber } from 'shell/constants/regex';
import * as yup from 'yup';

const validationSchema = yup.object().shape({
  authorizationData: yup
    .object()
    .shape({
      isMilanPlace: yup.boolean(),
      milan: yup
        .object()
        .shape({
          section: yup
            .string()
            .matches(regexOnlyNumber, 'Il campo deve essere numerico')
            .required('Campo obbligatorio'),
          requestDate: yup
            .date()
            .required('Il campo è obbligatorio')
            .nullable()
            .typeError('Data non valida'),
          collegioCamera: yup.string().matches(regexOnlyNumber, 'Il campo deve essere numerico'),
          collegioSenato: yup.string().matches(regexOnlyNumber, 'Il campo deve essere numerico'),
          collegioProvinciale: yup
            .string()
            .matches(regexOnlyNumber, 'Il campo deve essere numerico'),
        })
        .nullable(),
      outsideMilan: yup
        .object()
        .shape({
          requestDate: yup
            .date()
            .required('Il campo è obbligatorio')
            .nullable()
            .typeError('Data non valida'),
          municipality: yup.object().shape({}).required('Il campo è obbligatorio').nullable(),
        })
        .nullable(),
    })
    .nullable(),
});

export default validationSchema;
